import { render, staticRenderFns } from "./article4.vue?vue&type=template&id=2464c75a&"
import script from "./article4.vue?vue&type=script&lang=js&"
export * from "./article4.vue?vue&type=script&lang=js&"
import style0 from "./article4.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports